module.exports = __webpack_public_path__ + "static/media/champion.baa8038c.png";